// extracted by mini-css-extract-plugin
export default {"inputPin":"input-pin_inputPin__46fP7","title":"input-pin_title__8TT60","input":"input-pin_input__tBSJq"};